@if (canSeeApplyWorkflowBtn) {
  <button mat-menu-item (click)="applyWorkflow()">
    <mat-icon>group_work</mat-icon>
    <span>Apply Workflow</span>
  </button>
}
